import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ceremony from '../image/ceremony.jpeg';
import drum from '../image/drum.jpg';
import inOut1 from '../image/in_out1.jpg';
import inOut2 from '../image/in_out2.jpg';
import inOut3 from '../image/in_out3.jpg';
import outside1 from '../image/outside1.jpg';
import worship from '../image/worship.jpg';
import { translations } from '../locales/translations';

function HeroSection({ lang = 'ko' }) {
  const t = translations[lang];
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // 실제로 있는 이미지만 사용하도록 수정
  const slides = [
    { image: ceremony, caption: '은혜로운 예배' },
    { image: drum, caption: '찬양으로 하나되는 예배' },
    { image: inOut1, caption: '따뜻한 교제의 장소' },
    { image: inOut2, caption: '모두가 환영받는 공간' },
    { image: inOut3, caption: '은혜가 넘치는 예배' },
    { image: outside1, caption: '아름다운 성전' },
    { image: worship, caption: '함께 예배드리는 공동체' },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative h-screen">
      <AnimatePresence mode='wait'>
        {slides.map((slide, index) => (
          currentSlide === index && (
            <motion.div
              key={index}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
              className="absolute inset-0"
            >
              <div
                className="w-full h-full bg-cover bg-center"
                style={{
                  backgroundImage: `url(${slide.image})`,
                }}
              >
                <div className="absolute inset-0 bg-black/40" />
                <div className="absolute bottom-20 left-0 right-0 text-center">
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-white text-xl md:text-2xl font-body"
                  >
                    {slide.caption}
                  </motion.p>
                </div>
              </div>
            </motion.div>
          )
        ))}
      </AnimatePresence>

      <div className="absolute inset-0 flex items-center justify-center text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="w-full max-w-[90%] xl:max-w-[1400px] mx-auto px-4"
        >
          <h1 className="text-4xl sm:text-5xl md:text-5xl lg:text-7xl xl:text-7.8xl font-title font-bold text-white mb-6 leading-tight tracking-wider">
            {t.hero.title}
          </h1>
          <p className="text-xl sm:text-1xl md:text-2.5xl lg:text-4xl text-white font-heading font-semibold mb-8 tracking-widest">
            {t.hero.verse}
          </p>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-2.7xl text-white/90 font-korean leading-relaxed tracking-wide">
            {t.hero.description}
          </p>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all ${
              currentSlide === index ? 'w-8 bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export default HeroSection; 